"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = void 0;
var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "us";
    CountryCode["CA"] = "ca";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
//# sourceMappingURL=Types.js.map